import axios from "axios";

export function getParticipants(){
    return axios.request({
        method:'GET',
        url:'/api/quiz/getParticipants'
    })
}
export function getScoring(){
    return axios.request({
        method:'GET',
        url:'/api/quiz/getScoring'
    })
}
export function clearScore(){
    return axios.request({
        method:'POST',
        url:'/api/quiz/clearScore'
    })
}